import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Page, PageHeader } from "../components/PageHeader";
import DataTable from "../components/DataTable";
import StatusBadge from "../components/StatusBadge";
import OrderDetailDialog from "../components/OrderDetailDialog";
import { naira, fmtDateTime, titleCase } from "../lib/format";

export default function Orders() {
  const [rows, setRows] = useState([]); const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);
  useEffect(() => { api.get("/orders").then(setRows).finally(() => setLoading(false)); }, []);
  const columns = [
    { key: "number", label: "Order", render: (r) => <span className="font-semibold" style={{ color: "#8B1E1E" }}>{r.number}</span> },
    { key: "customer_name", label: "Customer" }, { key: "location_name", label: "Location" },
    { key: "served_by_name", label: "Served by", render: (r) => r.served_by_name || r.cashier_name || "—" },
    { key: "order_type", label: "Type", render: (r) => titleCase(r.order_type) },
    { key: "channel", label: "Channel", render: (r) => <span className="text-xs uppercase px-2 py-0.5 rounded" style={{ background: "#F3ECE2", color: "#765A4A" }}>{r.channel}</span> },
    { key: "date", label: "Time", render: (r) => fmtDateTime(r.date) },
    { key: "total", label: "Total", align: "right", render: (r) => <span className="font-semibold">{naira(r.total)}</span> },
    { key: "fulfilment_status", label: "Status", render: (r) => <StatusBadge status={r.fulfilment_status} /> },
    { key: "_view", label: "", render: (r) => (
      <button onClick={(e) => { e.stopPropagation(); setDetail(r); }} data-testid={`orders-view-${r.number}`}
        className="text-xs font-semibold underline" style={{ color: "#8B1E1E" }}>View</button>
    ) },
  ];
  return (
    <Page>
      <PageHeader title="Orders" subtitle="All POS & online orders — click any row for the full itemised order" />
      <DataTable columns={columns} rows={rows} loading={loading} onRowClick={(r) => setDetail(r)}
        searchKeys={["number", "customer_name", "location_name"]} testIdPrefix="orders" emptyText="No orders yet" />
      <OrderDetailDialog open={!!detail} order={detail} orderId={detail?.id} onClose={() => setDetail(null)} />
    </Page>
  );
}
